import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './styles/variables.css';
import './styles/base.css';
import './styles/activity-card.css';
import App from './App';
import { store } from './store/store';
import './i18n'; // initialize i18next (default instance) before anything renders
import { LanguageProvider } from './context/LanguageContext';
import { ThemeBridgeProvider } from './theme/ThemeBridgeProvider';
import { ToastProvider } from './components/reusable';
import { AuthProvider } from './auth/AuthProvider';
import { EMBEDDED_ENABLED } from './auth/embedded/embeddedConfig';
import reportWebVitals from './reportWebVitals';

// Embedded (iframe) mode: flag the document so the shell CSS can make #root the
// scroll container (styles/app-layout.css). The Relius parent's <iframe> may forbid
// document scrolling (scrolling="no" / fixed height), which would otherwise clip
// everything below the frame. Set once at boot — EMBEDDED_ENABLED is build-time.
if (EMBEDDED_ENABLED) document.documentElement.classList.add('is-embedded');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LanguageProvider>
        <ThemeBridgeProvider>
          <ToastProvider>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </ToastProvider>
        </ThemeBridgeProvider>
      </LanguageProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
